import {createFileRoute} from '@tanstack/react-router';
import SignUpPage from '@features/auth/signup/page';
import {z} from 'zod';

export const Route = createFileRoute('/auth/signup')({
  component: SignUpPage,
  validateSearch(search: object) {
    return z
      .object({
        email: z.string().optional(),
        source: z.string().optional(),
        inviteId: z.string().optional(),
      })
      .parse(search);
  },
});
